import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import EventOverview from '@/pages/home/components/EventOverview';
import ScheduleSection from '@/pages/home/components/ScheduleSection';
import SpeakersSection from '@/pages/home/components/SpeakersSection';
import RegistrationSection from '@/pages/home/components/RegistrationSection';
import PremiumSection from '@/pages/home/components/PremiumSection';
import ResourcesSection from '@/pages/home/components/ResourcesSection';
import heroBg from "@/assets/gna_business.jpg";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection backgroundImage={heroBg} />
        <EventOverview />
        <ScheduleSection />
        <SpeakersSection />
        <RegistrationSection />
        <PremiumSection />
        <ResourcesSection />
      </main>
    </div>
  );
};

export default HomePage;
